import React from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { Modal, Table } from 'antd'

// eslint-disable-next-line no-unused-vars
const headers = [
  strCol({
    ident: 'id',
    display: 'ID',
    isFiltered: true,
    width: 400,
  }),
  strCol({
    ident: 'sucess',
    display: 'Sucess',
    isFiltered: true,
  }),
  strCol({
    ident: 'tagName',
    display: 'PI Tag',
    isFiltered: true,
    width: 400,
  }),
  strCol({
    ident: 'missingDataPitag',
    display: 'Missing Data PI tag',
    isFiltered: true,
    width: 400,
  }),
]

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 100,
  },
  {
    title: 'Sucess',
    dataIndex: 'sucess',
    key: 'sucess',
    width: 100,
    render: text => (text === 'N' ? 'No' : 'Yes'),
  },
  {
    title: 'PI Tag',
    dataIndex: 'tagName',
    key: 'tagName',
    width: 250,
  },

  {
    title: 'Missing Data PI tag',
    dataIndex: 'missingDataPitag',
    key: 'missingDataPitag',
    width: 250,
  },
]

class PiImportStatusMannual extends React.Component {
  render() {
    const { data } = this.props
    return (
      <Modal
        title="PI Import Status"
        visible={data.length > 0}
        onOk={this.props.hide}
        onCancel={this.props.hide}
        destroyOnClose
        closable
        width={900}
        height={500}
        centered
        bodyStyle={{ width: '900px', height: '500px', minHeight: '500px' }}
        footer={false}
      >
        <Table
          columns={columns}
          dataSource={this.props.data}
          pagination={false}
          scroll={{ y: 400 }}
        />
        {/* <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell> ID</Table.HeaderCell>
                <Table.HeaderCell> Sucess</Table.HeaderCell>
                <Table.HeaderCell> Tag Name</Table.HeaderCell>
                <Table.HeaderCell> Missing Tag Name</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{getTableRow(data)}</Table.Body>
          </Table> */}
        {/* <div>
          <Grid
            data={this.props.data}
            headers={headers}
            render={virtualizedGridRenderer({
              headerRowHeight: 30,
              width: 800,
              height: 200,
              autoFixColByKey: true,
            })}
          />
        </div> */}
      </Modal>
    )
  }
}

export default PiImportStatusMannual
